import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ReactTimeAgo from "react-time-ago";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  Button,
  Container,
  Form,
  Card,
  Row,
  Col,
  Modal,
  Image,
  Table,
} from "react-bootstrap";
import "../Common/Common.css";
import "./notification.css";
import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");
TimeAgo.addDefaultLocale(en);

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      perPage: 10,
    };
  }

  componentDidMount() {
    this.props.fetchnotifications();
    this.props.shownNotifications();
  }

  changeStatus = (notification) => {
    {
      notification.read === false &&
        this.props.updateNotification(notification);
    }
  };

  navigatetothePage = (pageDetails) => {
    {
      pageDetails.orderTrk === "normal" &&
        pageDetails.event === "chemistDPurchase" &&
        this.props.history.push({
          pathname: "/normal-orders",
          activeTab: "new",
        });
    }
    {
      pageDetails.orderTrk === "normal" &&
        pageDetails.event === "chemistDDelivered" &&
        this.props.history.push({
          pathname: "/normal-orders",
          activeTab: "complete",
        });
    }
    {
      pageDetails.orderTrk === "normal" &&
        pageDetails.event === "chemistDAccept" &&
        this.props.history.push({
          pathname: "/normal-orders",
          activeTab: "processing",
        });
    }
    {
      pageDetails.orderTrk === "normal" &&
        pageDetails.event === "chemistDOrderCancel" &&
        this.props.history.push({
          pathname: "/normal-orders",
          activeTab: "cancel",
        });
    }
    {
      pageDetails.orderTrk === "urgent" &&
        pageDetails.event === "chemistDPurchase" &&
        this.props.history.push({
          pathname: "/orders",
          activeTab: "new",
        });
    }
    {
      pageDetails.orderTrk === "urgent" &&
        pageDetails.event === "chemistDDelivered" &&
        this.props.history.push({
          pathname: "/orders",
          activeTab: "complete",
        });
    }
    {
      pageDetails.orderTrk === "urgent" &&
        pageDetails.event === "chemistDAccept" &&
        this.props.history.push({
          pathname: "/orders",
          activeTab: "processing",
        });
    }
    {
      pageDetails.orderTrk === "urgent" &&
        pageDetails.event === "chemistDOrderCancel" &&
        this.props.history.push({
          pathname: "/orders",
          activeTab: "cancel",
        });
    }
    {
      pageDetails.event === "payment" &&
        this.props.history.push({
          pathname: "/payments",
        });
    }
    if (pageDetails.event === "expiryReturn") {
      this.props.history.push({
        pathname: "/expiryreturns",
      });
    }

    if (pageDetails.event === "return") {
      this.props.history.push({
        pathname: "/salesreturns",
      });
    }
    {
      pageDetails.event === "sprtTcktInprogress" &&
        this.props.history.push({
          pathname: "/support",
        });
    }
    {
      pageDetails.event === "sprtTcktClosed" &&
        this.props.history.push({
          pathname: "/support",
        });
    }
  };

  //For infinity scroll
  handleData = (e) => {
    window.scrollTo(0, 0);
    console.log(e);
    const selectednotificationPage = e.selected;
    this.props.NotificationPageSelected({
      page: selectednotificationPage + 1,
    });
    this.setState({ page: selectednotificationPage });
  };

  render() {
    const count = this.props.notificationCount;
    let p = this.state.page + 1;
    let notificationPageCount = Math.ceil(count / this.state.perPage);

    return (
      <div className="salesreturndiv">
        <Card>
          <div className="salesheader">
            <Row>
              <Col xs={6} sm={6} md={3} lg={3}>
                <div>
                  <h5 className="tablecardtitle">Notifications</h5>
                </div>
              </Col>
              <Col xs={2} sm={2} md={3} lg={3} />
              <Col xs={2} sm={2} md={3} lg={3} />
              <Col xs={2} sm={2} md={3} lg={3}>
                <div style={{ marginRight: "20px", marginTop: "6px" }}>
                  <Link to="/dashboard" onClick={() => window.scrollTo(0, 0)}>
                    <i className="fa fa-times fa-lg closeiconview " />
                  </Link>
                </div>
              </Col>
            </Row>
          </div>

          <Card.Body className="tableCardBody">
            <div className="tablecommonCardBody">
              <Table hover responsive className="ntfctionTable">
                {/* <InfiniteScroll
                dataLength={10} //This is important field to render the next data
                next={e=>this.handleData(e)}
                hasMore={true}
                loader={<h4>Loading...</h4>}
                endMessage={
                  <p style={{ textAlign: 'center' }}>
                    <b>Yay! You have seen it all</b>
                  </p>
                }
                // below props only if you need pull down functionality
                /* refreshFunction={this.refresh}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={
                  <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
                }
                releaseToRefreshContent={
                  <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
                } */
                /* > */}
                {this.props.notifications &&
                  this.props.notifications.map((item, i) => (
                    <tbody className="ntfctionBody">
                      <tr
                        className="ntfctionTr"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.changeStatus(item);
                          this.navigatetothePage(item);
                        }}
                        key={item.id}
                      >
                        <td className="cmn_notificationCap ntfctionTd ntfctionSpace">
                          <div className="ntfction">
                            <p style={{ marginTop: "3px" }}>
                              {item !== null && item.read ? (
                                <i className="fa fa-envelope-open  fa-sm " />
                              ) : (
                                <i className="fa fa-envelope  fa-sm " />
                              )}
                            </p>
                            <nspn className="nspnNoti"> </nspn>
                            <span style={{ width: "100%" }}>
                              {item !== null && item.sub}
                              <p className="notificationpera">
                                {item !== null && item.mesg}
                              </p>
                            </span>
                          </div>
                        </td>

                        <td className="cmnViewIcon ntfctionTd">
                          <p className="notificationpera pStyle">
                            {item !== null && item.createdAt ? (
                              <ReactTimeAgo
                                date={item.createdAt}
                                locale="en-US"
                              />
                            ) : null}
                            {/* <nspn className="ntfctionNspn"> </nspn> */}
                            <br />{" "}
                            {item !== null && item.createdAt
                              ? dateFormat(item.createdAt, "dd/mm/yyyy")
                              : null}
                            <nspn> - </nspn>
                            {item !== null && item.createdAt
                              ? dateFormat(item.createdAt, "h:MM TT")
                              : null}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                {/* </InfiniteScroll> */}
              </Table>
            </div>
            <br />
            {(this.props.notifications === undefined ||
              notificationPageCount === 0) && (
              <div>
                <div className="noDataImgDiv">
                  <Image
                    className="noDataImg"
                    src={require("../../assets/img/nodata4.png")}
                  />
                </div>
                <div className="noDataTextDiv">No notifications to show!</div>
              </div>
            )}
            {notificationPageCount > 1 ? (
              <div className="paginationDiv">
                <ReactPaginate
                  forcePage={this.state.page}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={notificationPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handleData}
                  containerClassName={"pagination flex-wrap"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            ) : null}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

//export default Notification;
export default withRouter(Notification);
